import { render, staticRenderFns } from "./MainHomeSkeleton.vue?vue&type=template&id=38c6efd9&"
import script from "./MainHomeSkeleton.vue?vue&type=script&lang=js&"
export * from "./MainHomeSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports